var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWelcomeImg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 375,
    height: 249,
    viewBox: "0 0 375 249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1377",
    "data-name": "Rectangle 1377",
    width: 375,
    height: 249,
    transform: "translate(488 142)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_5",
    "data-name": "Mask Group 5",
    transform: "translate(-488 -142)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4054",
    "data-name": "Group 4054",
    transform: "translate(-7.669)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Ribbon--inject-199",
    transform: "translate(431.441 75.895)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8910",
    "data-name": "Path 8910",
    d: "M132.33,223l-.75,70.94s-3,1.51-11.32,1.51-11.32-1.51-11.32-1.51l3-28.68S101.39,263,101.39,260s23.39-86,23.39-86S136.86,195.07,132.33,223Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    y1: 45.2,
    x2: 9.78,
    transform: "translate(111.95 220.05)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8911",
    "data-name": "Path 8911",
    d: "M115.73,173.94s13.58,18.11,15.09,25.66,1.51,23.4,1.51,23.4a123.8,123.8,0,0,0,8.3-34.71c1.51-18.87-13.58-28.68-13.58-28.68Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8912",
    "data-name": "Path 8912",
    d: "M370.92,223l.75,70.94s3,1.51,11.32,1.51,11.32-1.51,11.32-1.51l-3-28.68S401.86,263,401.86,260s-23.4-86-23.4-86S366.39,195.07,370.92,223Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 9.07,
    y1: 52.56,
    transform: "translate(382.22 212.69)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8913",
    "data-name": "Path 8913",
    d: "M387.52,173.94s-13.59,18.11-15.1,25.66-1.5,23.39-1.5,23.39a123.611,123.611,0,0,1-8.31-34.71c-1.51-18.87,13.59-28.68,13.59-28.68Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8914",
    "data-name": "Path 8914",
    d: "M387.41,173.94a266.85,266.85,0,0,0-271.68,0L91.91,133.66c-1.71-2.86-.1-7,3.65-9.06a319.7,319.7,0,0,1,312,0c3.74,2.09,5.36,6.2,3.65,9.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8915",
    "data-name": "Path 8915",
    d: "M387.41,173.94a266.85,266.85,0,0,0-271.68,0L91.91,133.66c-1.71-2.86-.1-7,3.65-9.06a319.7,319.7,0,0,1,312,0c3.74,2.09,5.36,6.2,3.65,9.06Z",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "W",
    transform: "matrix(0.952, -0.305, 0.305, 0.952, 138.94, 147.69)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 43.82,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "W")), /*#__PURE__*/React.createElement("text", {
    id: "E",
    transform: "translate(183.03 134.02) rotate(-12.095)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 44,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("text", {
    id: "L",
    transform: "translate(208.59 128.51) rotate(-7.481)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 44,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L")), /*#__PURE__*/React.createElement("text", {
    id: "C",
    transform: "matrix(0.999, -0.036, 0.036, 0.999, 233.1, 125.05)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 43.82,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    id: "O",
    transform: "translate(262.17 123.79) rotate(5.143)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 44,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "O")), /*#__PURE__*/React.createElement("text", {
    id: "M",
    transform: "translate(296.01 126.64) rotate(13.58)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 43.82,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "M")), /*#__PURE__*/React.createElement("text", {
    id: "E-2",
    "data-name": "E",
    transform: "translate(336.7 136.92) rotate(21.16)",
    fill: "#962cc6",
    stroke: "#25292b",
    strokeWidth: 1,
    fontSize: 43.82,
    fontFamily: "Segoe UI",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "E"))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-199",
    transform: "translate(408.673 79.898)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8916",
    "data-name": "Path 8916",
    d: "M338.18,220.6s-12.72-9.4-18.83-14-16.58-17.8-19.2-23.6a91,91,0,0,0-4.36-8.73S297,168.44,297,167s-1.17-3.34-1.91-4.56c-.37-.61-3-4.1-3-1.44,0,2.08,1.25,3.12,1.25,4.37h0a10.21,10.21,0,0,1-4-4c-1.46-2.7-2.08-3.75-2.92-3.12-1.49,1.12.42,4,.42,4s-.42-4-2.5-3.34c-1.2.36.42,3.75,1.25,5.21s-.42-1-.21,1.46c.15,1.83,2.24,6.33,4.17,8.54.7.81,2.33.56,2.5.84.62,1,7.29,16.46,11.87,24.17s7.3,10,11.05,13.75,8.75,10.21,13.12,13.33,6.67,1.88,9.17-.21S340.13,222.72,338.18,220.6Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8917",
    "data-name": "Path 8917",
    d: "M293.27,165.36s-1.88,3.55-1,5",
    fill: "none",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x2: 1.67,
    y2: 3.12,
    transform: "translate(286.81 162.24)",
    fill: "none",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8918",
    "data-name": "Path 8918",
    d: "M288.68,172.45a35.923,35.923,0,0,1-3.75-5.84c-.83-2.08-.2-6.66,1.05-5.83s.83,5.42.83,5.42l2.5,2.91",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8919",
    "data-name": "Path 8919",
    d: "M340.87,194.62s-6.39-2.33-5.23-10.47,8.14-4.07,8.14-4.07-7-9.31,7.27-11.34,24.73,10.76,28.22,25-18.62,15.7-15.42,26.47,15.71,23,13.67,37.81-22.39,23-31.7,15.12S332.73,253.08,338,242s8.14-24.14,9.59-30S340.87,194.62,340.87,194.62Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8920",
    "data-name": "Path 8920",
    d: "M363.75,205.5C355,202,350.5,187.75,350.5,179.75s11.25-4,11.25-4-11,2-5.5,12.75,15.25,14,20.25,10.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8921",
    "data-name": "Path 8921",
    d: "M362,213.25s-7.75,2.5-5.5,12.25S376,247.5,371,260s-13.75,17.5-24.25,13.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8922",
    "data-name": "Path 8922",
    d: "M358.25,215.25s-8.5,3.5-9.5,16,9.25,23.25,4.5,29.5-12.5,5.5-15,1.75",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8923",
    "data-name": "Path 8923",
    d: "M338.84,208.29s.87,3.2-2,8.15-4.36,6.1-4.36,6.1l10.47-.87,6.69-12.22S339.42,210.33,338.84,208.29Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8924",
    "data-name": "Path 8924",
    d: "M349.31,181.24s-10.18,9.31-12.22,17.45.58,13.38,4.37,13.38,11.63-3.2,11.63-3.2,2.33,2,4.65.88a4.14,4.14,0,0,0,2.33-3.49S344.07,190.55,349.31,181.24Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8925",
    "data-name": "Path 8925",
    d: "M345,195.21c-.7.89-1.54,1.39-1.89,1.12s-.07-1.21.63-2.1,1.54-1.39,1.88-1.12S345.69,194.32,345,195.21Z",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8926",
    "data-name": "Path 8926",
    d: "M349.84,200.28c-.69.9-1.54,1.4-1.89,1.13s-.06-1.21.63-2.1,1.54-1.4,1.89-1.13S350.53,199.39,349.84,200.28Z",
    fill: "#2e353a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8927",
    "data-name": "Path 8927",
    d: "M344.54,197.11a18.929,18.929,0,0,0-3.41,1.6c-.91.68.68,1.59.68,1.59",
    fill: "none",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8928",
    "data-name": "Path 8928",
    d: "M339.08,202.57a3.49,3.49,0,0,0,3.19,2.73,5.83,5.83,0,0,0,4.09-.91",
    fill: "none",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8929",
    "data-name": "Path 8929",
    d: "M344.77,189.38a2.79,2.79,0,0,1,3.18,2.28",
    fill: "none",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8930",
    "data-name": "Path 8930",
    d: "M350,195.07s3.86,1.36,2.73,4.32",
    fill: "none",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8931",
    "data-name": "Path 8931",
    d: "M311.84,407.19s-5.38,3.59-7.18,4.48-9.41,2.24-9.64,4.26,3.81,3.14,8.3,3.14,9.86,0,12.55.45,4.49,1.34,5.61-1.57-.68-10.54-.68-10.54S316.1,409.21,311.84,407.19Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M313.85,327.38s-3.13,14.57-3.13,19.28,1.79,35.2,2.24,43.71a80.312,80.312,0,0,1-1.12,16.82s3.81,1.79,5.38,1.79,3.58-1.57,3.58-1.57,4.49-19.73,4.49-30.26.89-16.59,0-23.32-4-19.05-2.92-23.54S317.22,320.65,313.85,327.38Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M313.82,263S310,288.86,310,308.05s8.15,42.18,10.18,45.38,19.78,35.19,23.85,41.88a90.79,90.79,0,0,1,7.12,15.94,21.938,21.938,0,0,0,4.36.87c1.46,0,3.49-1.74,3.49-1.74s-9.44-36.89-13.22-46.48-11.6-17.16-13.63-20.9-2.91-18.33-2.91-18.33,11.92-18.9,14-29.08S339.71,274,337.38,270a78.638,78.638,0,0,1-4.07-8.43S321.1,268.79,313.82,263Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M335.93,252.5s7.27-22.39,9-27.63-.88-7.27-8.73-6.4-21.52,7-22.1,13.67,2,10.47,2,13.67S311.5,263,315,265.88s14.54,2,17.74-2S335.93,252.5,335.93,252.5Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M338.18,220.6a15.43,15.43,0,0,1-2.54,10.4c-3.49,5.52-11.34,3.49-10.76-2.62S332.86,217.2,338.18,220.6Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    "data-name": "Path 8936",
    d: "M333.22,229.26a6.44,6.44,0,0,0,5-8.66,3.71,3.71,0,0,0-2.83-2.42c-5-.87-26.76.87-32.29.29s-26.46-13.38-32-18.32-7.56-7.56-7.56-9.6-1.46-6.69-2.62-8.14-3.2-4.37-3.2-4.37-2,0-1.74,1.17a24.92,24.92,0,0,0,1.74,3.78s-5.82-3.49-7.27-5a1.78,1.78,0,0,0-2.62-.29l3.2,3.49s-.29,2.33,2,6.11a27,27,0,0,0,6.4,6.69s11.63,13.67,20.36,21.23,16.86,12.22,24.14,13.38C310.35,229.68,320.37,231.61,333.22,229.26Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8937",
    "data-name": "Path 8937",
    d: "M351.19,411.25s-4.6,4.91-7.74,6.92-7.18,3.37-6.5,5.16,9,1.57,13,1.34,12.1-4,13.45-4.93-4.36-9.36-4.36-9.36S354.67,412.84,351.19,411.25Z",
    fill: "#fff",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8938",
    "data-name": "Path 8938",
    d: "M350,424.67c4-.22,12.1-4,13.45-4.93.37-.25.19-1.09-.25-2.16a63.807,63.807,0,0,1-14.32,5.08c-6.56,1.4-10.28.74-11.95.21a1.261,1.261,0,0,0,.07.46C337.62,425.12,345.91,424.9,350,424.67Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8939",
    "data-name": "Path 8939",
    d: "M321.48,418a6.37,6.37,0,0,0,.33-1.84c-1.78,1.44-3.07.76-5.94.94-3.59.23-4.93.23-12.33.23a22.92,22.92,0,0,1-8.5-1.41.14.14,0,0,1,0,.06c-.22,2,3.81,3.14,8.3,3.14s9.86,0,12.55.45S320.36,420.86,321.48,418Z",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8940",
    "data-name": "Path 8940",
    d: "M329.24,324.63s.83-13.84,2.36-16.58,5.17-6.39,7.6-8.52",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.75
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeImg);
export default __webpack_public_path__ + "static/media/welcome-img.d225a437fe3dea4b9681ef1f9b1e0dfa.svg";
export { ForwardRef as ReactComponent };